import { render, staticRenderFns } from "./BaseFormRadioButton.vue?vue&type=template&id=4a9fecf8&scoped=true&"
import script from "./BaseFormRadioButton.vue?vue&type=script&lang=js&"
export * from "./BaseFormRadioButton.vue?vue&type=script&lang=js&"
import style0 from "./BaseFormRadioButton.vue?vue&type=style&index=0&id=4a9fecf8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a9fecf8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
installComponents(component, {VRadio})
